import { html, Html, View } from 'rune-ts';
import { NessBadgeView } from './NessBadgeView.ts';
import { createNessBadges } from '@modules/Ness/App/ProductBadge';
import {
  ITimerSubscribable,
  TimerSubscriptionManager,
  TimerTick,
} from '@services/MarppleShop/shared/util/timer';
import klass from './NessBadgeListView.module.scss';

type TProps =
  | {
      goodsTypeId: 'MPS' | 'DTG';
      publicAt: Date;
      rank?: number;
      isCustom: boolean;
      legacyStock: {
        totalQuantity: number;
        orderCount: number;
        isQuantityPublic: boolean;
        isOutOfStock: boolean;
      };
      salePeriod: {
        startDate?: Date;
        endDate?: Date;
      };
      discountPercentage?: number;
      debugInfo?: {
        productId?: number;
        displayName?: string;
      };
    }
  | {
      goodsTypeId: 'PBG' | 'TPL';
      publicAt: Date;
      rank?: number;
      isCustom: boolean;
      limitedMeta?: {
        isLimited: boolean;
      };
      lowStockMeta?: {
        threshold: number;
      };
      stock: {
        availableStock: number;
      };
      salePeriod: {
        startDate?: Date;
        endDate?: Date;
      };
      discountPercentage?: number;
      debugInfo?: {
        productId?: number;
        displayName?: string;
      };
    };

export class NessBadgeListView
  extends View<
    TProps & {
      baseTimestamp?: number;
    }
  >
  implements ITimerSubscribable
{
  private timerSubscription?: TimerSubscriptionManager;

  onTimerTick(event: TimerTick): void {
    this.data.baseTimestamp = event.detail.timestamp;
    this.redraw();
  }

  destroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  protected override onRender(): void {
    super.onRender();

    this.timerSubscription = new TimerSubscriptionManager(this);
    if (!this.timerSubscription.isSubscribed) {
      this.timerSubscription.subscribe();
    }
  }

  protected override onUnmount(): void {
    super.onUnmount();
    this.destroy();
  }

  protected override template(): Html {
    const badges = createNessBadges(this.data);

    if (badges.length > 0) {
      return html`<div class="${klass.ness_badge_list}">
        ${badges.map((item) => new NessBadgeView(item))}
      </div>`;
    } else {
      return html`<div></div>`;
    }
  }
}

export type TNessBadgeListViewProps = TProps;
